<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Filter Maintenance Records</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    (click)="onClose()"
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="filter-content d-flex m-0 pt-4 pb-2 flex-wrap" style="justify-content: space-evenly">

  <ng-container matColumnDef="maintenance_schedules">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onSelectSchedules()"
        [matBadge]="'' + (filters.schedule_ids.length || 'All')"
        class="mx-3 mt-2">
        <mat-icon>date_range</mat-icon> Scheduled Maintenance
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="contractors" *ngIf="canViewNetworkedAccounts">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onSelectContractors()"
        [matBadge]="'' + (filters.contractor_ids.length || 'All')"
        class="mx-3 mt-2">
        <fa-icon [icon]="faHardHat"></fa-icon> {{ utils.getLangTerm('contractors.plural', 'Contractors') }}
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="vendors">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onSelectVendors()"
        [matBadge]="'' + (filters.vendor_ids.length || 'All')"
        class="mx-3 mt-2">
        <mat-icon>store</mat-icon> Vendors
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="users" *ngIf="canViewNetworkedUsers">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onSelectUsers()"
        [matBadge]="'' + (filters.user_ids.length || 'All')"
        class="mx-3 mt-2">
        <mat-icon>people</mat-icon> Assigned Users
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="status">
    <div style="padding: 5px !important;">
      <mat-form-field style="width: 160px;" class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic">
        <mat-label>Status</mat-label>
        <mat-select
          [(ngModel)]="filters.status"
          placeholder="Status"
          name="status"
          matTooltip="Toggle between Statuses">
          <mat-option value="all" aria-selected="true">All</mat-option>
          <mat-option *ngFor="let status of statusOptions" [value]="status.value">{{ status.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="type">
    <div style="padding: 5px !important;">
      <mat-form-field style="width: 200px;" class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic">
        <mat-label>Type</mat-label>
        <mat-select
          [(ngModel)]="filters.type"
          placeholder="Type"
          name="type"
          matTooltip="Toggle between Types">
          <mat-option value="all" aria-selected="true">All</mat-option>
          <mat-option *ngFor="let type of typeOptions" [value]="type.value">{{ type.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="priority">
    <div style="padding: 5px !important;">
      <mat-form-field style="width: 160px;" class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic">
        <mat-label>Priority</mat-label>
        <mat-select
          [(ngModel)]="filters.priority"
          placeholder="Priority"
          name="priority"
          matTooltip="Toggle between Priorities">
          <mat-option value="all" aria-selected="true">All</mat-option>
          <mat-option *ngFor="let priority of priorityOptions" [value]="priority.value">{{ priority.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="active_archived">
    <div style="padding: 5px !important;">
      <mat-form-field style="width: 160px;" class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic">
        <mat-label>Active/Archived</mat-label>
        <mat-select
          [(ngModel)]="filters.archived"
          placeholder="Active/Archived"
          name="status"
          matTooltip="Toggle between Archived and Active records">
          <mat-option value="false" aria-selected="true">Active</mat-option>
          <mat-option value="true">Archived</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="date_filter_by">
    <div style="padding: 5px !important;">
      <mat-form-field style="width: 200px;" class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic">
        <mat-label>Date Filter By</mat-label>
        <mat-select
          placeholder="Date Filter By"
          [(ngModel)]="filters.date_type"
          name="date_filter"
          matTooltip="Filter maintenance records by the date type selected.">
          <mat-option value="due_at">Due Date</mat-option>
          <mat-option value="started_at">Started At</mat-option>
          <mat-option value="completed_at">Completed At</mat-option>
          <mat-option value="cancelled_at">Cancelled At</mat-option>
          <mat-option value="date_created">Created At Date</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="date_range">
    <div style="padding: 0 1px !important;">
      <app-date-range-picker dateRangeTitle="Date Range" dateRangePlaceholder="Select Date Range" dateRangeTooltip="Filter by the selected date type option." [dateRangeInput]="filters.date_range" (dateRangeOutput)="getOutputDateRange($event)"></app-date-range-picker>
    </div>
  </ng-container>

</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex flex-wrap justify-content-center my-2 py-2">
  <ng-container matColumnDef="buttons">
    <div class="p-2">
      <button
        type="button"
        mat-raised-button
        color="primary"
        (click)="onSaveAndClose()" >
        <mat-icon>filter_list</mat-icon> Apply Filter
      </button>
    </div>

    <div class="p-2">
      <button
        type="button"
        mat-raised-button
        color="secondary"
        (click)="onClearAndClose()" >
        <mat-icon> clear_all</mat-icon> Clear Filter
      </button>
    </div>

    <div class="p-2" *ngIf="filters.date_range.length == 2">
      <button
        type="button"
        mat-raised-button
        color="secondary"
        (click)="onClearDateRange()">
        <mat-icon>clear</mat-icon> Clear Date Range
      </button>
    </div>
  </ng-container>
</mat-dialog-actions>
